import { render, staticRenderFns } from "./SixPage.vue?vue&type=template&id=c031c26c&scoped=true&"
import script from "./SixPage.vue?vue&type=script&lang=js&"
export * from "./SixPage.vue?vue&type=script&lang=js&"
import style0 from "./SixPage.vue?vue&type=style&index=0&id=c031c26c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c031c26c",
  null
  
)

export default component.exports